import {action, observable} from "mobx";

import regionService from "../services/regionService";
import appStore from "./appStore";
import meStore from "./meStore";
import config from "../_core/config";

class regionStore {
    @action getRegionList = async params => {
        const resultOfRequest = await regionService.getRegionList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getRegionListByCities = async params => {
        const resultOfRequest = await regionService.getRegionListByCities(params);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateRegionName = async params => {
        const resultOfRequest = await regionService.updateRegionName(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };


    @action getRegionGroups = async params => {
        const resultOfRequest = await regionService.getRegionGroups(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action addOrUpdateRegionGroups = async params => {
        const resultOfRequest = await regionService.addOrUpdateRegionGroups(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getUpperGroupsByCompanyIdAndCity = async params => {
        const resultOfRequest = await regionService.getUpperGroupsByCompanyIdAndCity(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getUpperGroupsByCities = async params => {
        const resultOfRequest = await regionService.getUpperGroupsByCities(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new regionStore();
